// extracted by mini-css-extract-plugin
module.exports = {"container":"chart_legend-module__container--dskLn"};